import React from 'react';

const IconLocation = () => {
  return (
    <div>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.1875 8.9375C17.1875 7.29647 16.5356 5.72266 15.3752 4.56228C14.2148 3.4019 12.641 2.75 11 2.75C9.35897 2.75 7.78516 3.4019 6.62478 4.56228C5.4644 5.72266 4.8125 7.29647 4.8125 8.9375C4.8125 11.4757 6.84337 14.784 11 18.7467C15.1566 14.784 17.1875 11.4757 17.1875 8.9375ZM11 20.625C5.95787 16.0421 3.4375 12.1454 3.4375 8.9375C3.4375 6.9318 4.23426 5.00825 5.65251 3.59001C7.07075 2.17176 8.9943 1.375 11 1.375C13.0057 1.375 14.9293 2.17176 16.3475 3.59001C17.7657 5.00825 18.5625 6.9318 18.5625 8.9375C18.5625 12.1454 16.0421 16.0421 11 20.625Z"
          fill="#455976"
        />
        <path
          d="M11 11C11.547 11 12.0716 10.7827 12.4584 10.3959C12.8452 10.0091 13.0625 9.48451 13.0625 8.9375C13.0625 8.39049 12.8452 7.86589 12.4584 7.47909C12.0716 7.0923 11.547 6.875 11 6.875C10.453 6.875 9.92839 7.0923 9.54159 7.47909C9.1548 7.86589 8.9375 8.39049 8.9375 8.9375C8.9375 9.48451 9.1548 10.0091 9.54159 10.3959C9.92839 10.7827 10.453 11 11 11V11ZM11 12.375C10.0883 12.375 9.21398 12.0128 8.56932 11.3682C7.92466 10.7235 7.5625 9.84918 7.5625 8.9375C7.5625 8.02582 7.92466 7.15148 8.56932 6.50682C9.21398 5.86216 10.0883 5.5 11 5.5C11.9117 5.5 12.786 5.86216 13.4307 6.50682C14.0753 7.15148 14.4375 8.02582 14.4375 8.9375C14.4375 9.84918 14.0753 10.7235 13.4307 11.3682C12.786 12.0128 11.9117 12.375 11 12.375Z"
          fill="#455976"
        />
      </svg>
    </div>
  );
};

export default IconLocation;
